"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>RealTimeHeader
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const RealtimeHeaderIcon_js_namespaceObject = require("../../../svgs/RealtimeHeaderIcon.js");
var RealtimeHeaderIcon_js_default = /*#__PURE__*/ __webpack_require__.n(RealtimeHeaderIcon_js_namespaceObject);
const RealtimeWaveIcon_js_namespaceObject = require("../../../svgs/RealtimeWaveIcon.js");
var RealtimeWaveIcon_js_default = /*#__PURE__*/ __webpack_require__.n(RealtimeWaveIcon_js_namespaceObject);
const external_pcln_icons_namespaceObject = require("pcln-icons");
const ChatbotDataContext_js_namespaceObject = require("../../../context/ChatbotDataContext.js");
const StyledTooltip = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Tooltip).withConfig({
    displayName: "RealTimeHeader__StyledTooltip"
})([
    "left:",
    ";width:",
    ";text-align:left;"
], ({ isMobile })=>isMobile ? '16px' : '-8px', ({ isMobile, isStandalone })=>isStandalone && isMobile ? '145px' : '300px');
const RealTimeHeader_RealTimeHeader = ({ isStandalone })=>{
    const [isDisplayed, setTooltipDisplayState] = (0, external_react_namespaceObject.useState)(false);
    const { isMobile } = (0, external_react_namespaceObject.useContext)(ChatbotDataContext_js_namespaceObject.ChatbotDataContext);
    const IconButtonProps = {
        ml: 2,
        id: 'openTooltipButton',
        'data-testid': 'openTooltipButton',
        title: 'open tooltip',
        onClick: (e)=>{
            e.preventDefault();
            setTooltipDisplayState(!isDisplayed);
        },
        icon: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.InformationOutline, {
            size: 16
        })
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
        alignItems: 'center',
        justifyContent: 'center',
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeHeaderIcon_js_default(), {}),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Badge, {
                color: "primary",
                bg: "background.light",
                ml: 1,
                children: "BETA"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                mr: "0",
                color: 'white',
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.IconButton, {
                        ...IconButtonProps,
                        onClick: function() {
                            setTooltipDisplayState(!isDisplayed);
                        }
                    }),
                    isDisplayed && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(StyledTooltip, {
                        isStandalone: isStandalone,
                        bg: "background.darkest",
                        color: "background.lightest",
                        center: isMobile,
                        left: !isMobile,
                        isMobile: isMobile,
                        children: [
                            "Powered by OpenAI. Chat transcripts are recorded for quality review purposes. Penny can make mistakes. Please do not share any personal information in the chat.",
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("br", {}),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("br", {}),
                            "\xa9 ",
                            new Date().getFullYear(),
                            " Priceline - Patent Pending"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealtimeWaveIcon_js_default(), {})
        ]
    });
};
const RealTimeHeader = RealTimeHeader_RealTimeHeader;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
